import WidgetsMgr from 'widgets/widgetsMgr';

WidgetsMgr.addWidgetsList('app_custom_core', () => []);
